import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { useGeolocation } from 'state/geolocation';
import DEFAULT_MAP_ZOOM from 'utils/restaurant/default-map-zoom';

import { ResetLocationButton } from '../../reset-location-button';

import { IMapButtonsProps } from './types';

/**
 *
 * MapButtons handles logic & UI for the Search This Area
 *  and Reset Location buttons within the map container.
 *
 */
export const MapButtons: FC<IMapButtonsProps> = ({
  currentViewIsMap,
  handleResetLocation,
  hasPanned,
  isDesktop,
  isMobileFullScreen,
  onClickSearch,
  zoom,
}) => {
  const { formatMessage } = useIntl();
  const { loadingUserCoordinates } = useGeolocation();

  if (!currentViewIsMap) {
    return null;
  }

  return (
    <>
      <Box
        position="absolute"
        center
        bottom="1rem"
        show={hasPanned && zoom >= DEFAULT_MAP_ZOOM}
        margin={isMobileFullScreen ? '0 0 env(safe-area-inset-bottom)' : '0'}
        data-testid="map-buttons"
      >
        <ActionButton
          size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
          onClick={onClickSearch}
          data-testid="search-this-area-button"
        >
          {formatMessage({ id: 'searchThisArea' })}
        </ActionButton>
      </Box>

      <Box
        position="absolute"
        bottom={isDesktop ? '2rem' : '1rem'}
        right={isDesktop ? '2rem' : '1rem'}
      >
        <ResetLocationButton onClick={handleResetLocation} loading={loadingUserCoordinates} />
      </Box>
    </>
  );
};

export default MapButtons;
